<template>
  <v-radio
    v-bind="$attrs"
    v-on="$listeners"
    :class="$style.radio"
    active-class="activeItem"
    :ripple="false"
    on-icon="mdi-radiobox-blank"
  >
    <slot
      v-for="(_, name) in $slots"
      :slot="name"
      :name="name"
    />

    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </v-radio>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Radio extends Vue {
}
</script>

<style module lang="scss">
.radio {

  :global(.v-input--selection-controls__input:after) {
    content: '';
    width: 10px;
    height: 10px;
    background-color: #000;
    border-radius: 50%;
    opacity: 0;
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    top: 50%;
    transition: opacity 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  }

  :global(.v-label) {
    color: $primary_darken1;
  }

  :global(.v-icon) {
    color: $primary_lighten2;
  }

  &:hover {
    :global(.v-icon) {
      color: $primary_base;
    }
  }

  &:focus,
  &:global(.v-radio--is-focused) {
    :global(.v-icon) {
      color: $accent_darken3 !important;
    }
  }

  // active
  &:global(.activeItem) {
    :global(.v-icon) {
      color: $accent_darken3 !important;
    }

    // active disabled
    &:global(.v-radio--is-disabled) {
      :global(.v-icon) {
        color: $primary_lighten2 !important;
      }
    }

    :global(.v-input--selection-controls__input:after) {
      opacity: 1;
    }

    &:hover {
      :global(.v-icon) {
        color: $accent_darken1 !important;
      }

    :global(.v-input--selection-controls__input:after) {
        background-color: $primary_darken1
      }
    }

    &:focus,
    &:global(.v-radio--is-focused) {
      :global(.v-icon) {
        color: $accent_darken2 !important;
      }

    :global(.v-input--selection-controls__input:after) {
        background-color: $primary_darken1
      }
    }
  }

  // disabled
  &:global(.v-radio--is-disabled) {
    :global(.v-icon),
    :global(.v-label) {
      color: $primary_lighten2 !important;
    }

    :global(.v-input--selection-controls__input:after) {
      background-color: $primary_lighten2;
    }
  }
}
</style>
